/* router/index.js 路由配置 */

import { Vue, NProgress } from "@plugins";

// 引入 Vue 路由
import VueRouter from "vue-router";

// 引入 Vuex
import store from "@store";

import { isMobile } from "@utils/index.js";

// 菜单列表
import menu from "@assets/js/menu.js";

Vue.use(VueRouter);

// 动态加载页面
const importPage = (name = "index/index.vue") => {
  if (isMobile()) {
    return () => import(`@pages/${name}`);
  } else {
    return () => import(`@views/${name}`);
  }
};

const Layout = importPage("layout/index.vue");

const getAdminInfo = () => {
  let storeState = sessionStorage.getItem("jr_adminStore")
    ? JSON.parse(sessionStorage.getItem("jr_adminStore"))
    : store.state || null;

  let adminInfo =
    storeState && storeState.admin ? storeState.admin.adminInfo || [] : [];

  if (!adminInfo) {
    getAdminInfo();
  } else {
    return adminInfo;
  }
};

var adminInfo = getAdminInfo();

const routes = [
  // Error 404 页面
  {
    path: "*",
    name: "Error",
    meta: {
      title: "404 Not Found",
    },
    component: importPage("error/index.vue"),
  },
  // 首页
  {
    path: "/",
    name: "Index",
    redirect: "/layout/welcome",
    meta: {
      title: "后台管理系统",
    },
    component: importPage("index/index.vue"),
  },
  // 登录页
  {
    path: "/login",
    name: "Login",
    meta: {
      title: "登录",
    },
    component: importPage("login/index.vue"),
  },
];

let routerList = store.state.routerList || [];

let menuList = store.state.menuList || [];

/**
 * 字符串转数组
 * @param {String} string
 * @param {String} separator
 * @param {Boolean} is_number
 * @returns
 */
const $stringToArray = (string, separator = ",", is_number = true) => {
  let list = [];

  string += "";

  if (new String(string).length) {
    list = string.split(separator); // 以逗号,为拆分的字符串

    if (is_number) {
      list.forEach((value, index) => {
        list[index] = parseInt(value);
      });
    }
  }

  return list;
};

const initRouterList = (menuData, level = 1) => {
  // 如果 menuData 不是数组或为空，返回空数组
  if (!menuData || !Array.isArray(menuData)) {
    return [];
  }

  let menu_id = $stringToArray(adminInfo.menu_id);

  let menu_pid = $stringToArray(adminInfo.menu_pid);

  // 合并
  menu_id = menu_id.concat(menu_pid);

  const processRouter = (menuItem, level = 1) => {
    if (!menuItem.isRouter) {
      return null;
    }

    if (!menu_id.includes(menuItem.id)) {
      return false;
    }

    // 路由信息
    const routerInfo = {
      path: menuItem.path,
      name: menuItem.name,
      meta: {
        title: menuItem.title,
        level,
      },
      component: menuItem.isLayout ? Layout : importPage(menuItem.component),
      children: [],
    };

    // 如果存在子级列表
    if (menuItem.children && menuItem.children.length > 0) {
      routerInfo.children = menuItem.children
        .map((children) => processRouter(children, level + 1))
        .filter(Boolean);
    }

    return routerInfo;
  };

  const processMenu = (menuItem, level = 1) => {
    if (!menuItem.isMenu) {
      return null;
    }

    if (!menu_id.includes(menuItem.id)) {
      return false;
    }

    // 路由信息
    const menuInfo = {
      path: menuItem.path,
      name: menuItem.name,
      title: menuItem.title,
      icon: menuItem.icon,
      meta: {
        title: menuItem.title,
        level,
      },
      children: [],
    };

    // 如果存在子级列表
    if (menuItem.children && menuItem.children.length > 0) {
      menuInfo.children = menuItem.children
        .map((children) => processMenu(children, level + 1))
        .filter(Boolean);
    }

    return menuInfo;
  };

  return {
    routerList: menuData
      .map((menuItem) => processRouter(menuItem, level))
      .filter(Boolean),
    menuList: menuData
      .map((menuItem) => processMenu(menuItem, level))
      .filter(Boolean),
  };
};

if (routerList.length > 0) {
  // 如果路由列表已存在，则直接使用
  routes.push(...routerList);
} else {
  let result = initRouterList(menu);
  // 初始化路由列表
  routerList = result.routerList || [];

  menuList = result.menuList || [];

  // 添加路由列表
  routes.push(...routerList);
}

/* 防止连续点击多次路由报错 */
const routerPush = VueRouter.prototype.push;

const routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 开启进度条
  NProgress.start();

  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = process.env.VUE_APP_TITLE + " - " + to.meta.title;
  }

  if (to.path === "/login") {
    sessionStorage.removeItem("jr_adminIsInit");

    store.commit("setIsInit", false);

    next();
  } else {
    if (!adminInfo.id) {
      adminInfo = getAdminInfo();
    }
    if (adminInfo.token) {
      next();
    } else {
      sessionStorage.removeItem("jr_adminIsInit");

      store.commit("setIsInit", false);

      next({
        path: "/login",
      });
    }
  }
});

let isInit =
  store.state.isInit || sessionStorage.getItem("jr_adminIsInit") || false;

// 路由后置守卫
router.afterEach((to, from) => {
  if (!isInit && to.path !== "/login") {
    sessionStorage.setItem("jr_adminIsInit", true);

    store.commit("setIsInit", true);

    location.reload();
  }

  store.commit("setRouterList", routerList);

  store.commit("setMenuList", menuList);

  // 关闭进度条
  NProgress.done();
});

export default router;
